import { label } from "framer-motion/client";

export const jobOptions = [
  { label: "Software Engineer", value: "Software Engineer" },
  { label: "Frontend Developer", value: "Frontend Developer" },
  { label: "Backend Developer", value: "Backend Developer" },
  { label: "Full Stack Developer", value: "Full Stack Developer" },
  { label: "Data Scientist", value: "Data Scientist" },
  { label: "Product Manager", value: "Product Manager" },
  { label: "UI/UX Designer", value: "UI/UX Designer" },
  { label: "Graphic Designer", value: "Graphic Designer" },
  { label: "Digital Marketing Manager", value: "Digital Marketing Manager" },
  { label: "Content Writer", value: "Content Writer" },
  { label: "SEO Specialist", value: "SEO Specialist" },
  { label: "Business Analyst", value: "Business Analyst" },
  { label: "Project Manager", value: "Project Manager" },
  { label: "HR Manager", value: "HR Manager" },
  {
    label: "Customer Support Specialist",
    value: "Customer Support Specialist",
  },
  { label: "Sales Executive", value: "Sales Executive" },
  { label: "Financial Analyst", value: "Financial Analyst" },
  { label: "Network Administrator", value: "Network Administrator" },
  { label: "Cybersecurity Analyst", value: "Cybersecurity Analyst" },
  { label: "Cloud Engineer", value: "Cloud Engineer" },
  { label: "DevOps Engineer", value: "DevOps Engineer" },
  { label: "Mobile App Developer", value: "Mobile App Developer" },
  { label: "Technical Recruiter", value: "Technical Recruiter" },
  { label: "IT Support Specialist", value: "IT Support Specialist" },
  { label: "QA Engineer", value: "QA Engineer" },
];

export const financeMangerOptions = [
  { label: "Finance Manager 1", value: 1 },
  { label: "Finance Manager 2", value: 2 },
  { label: "Finance Manager 3", value: 3 },
  { label: "Finance Manager 4", value: 4 },
];
export const hrMangerOptions = [
  { label: "HR Manager 1", value: 1 },
  { label: "HR Manager 2", value: 2 },
  { label: "HR Manager 3", value: 3 },
];

export const countryListOptions = [
  { label: "India", value: "India" },
  { label: "Australia", value: "Australia" },
];

export const cityStateListOptions = [
  { label: "Hyderabad - Telangana", value: "Hyderabad-Telangana" },
  { label: "Vijayawada - Andhrapradesh", value: "Vijayawada-Andhrapradesh" },
];

export const countryOptions = [
  { label: "United States", value: "United States" },
  { label: "Canada", value: "Canada" },
  { label: "United Kingdom", value: "United Kingdom" },
  { label: "Australia", value: "Australia" },
  { label: "Germany", value: "Germany" },
  { label: "France", value: "France" },
  { label: "India", value: "India" },
  { label: "China", value: "China" },
  { label: "Japan", value: "Japan" },
  { label: "Brazil", value: "Brazil" },
  { label: "Mexico", value: "Mexico" },
  { label: "South Africa", value: "South Africa" },
  { label: "Italy", value: "Italy" },
  { label: "Spain", value: "Spain" },
  { label: "Netherlands", value: "Netherlands" },
  { label: "Russia", value: "Russia" },
  { label: "South Korea", value: "South Korea" },
  { label: "New Zealand", value: "New Zealand" },
  { label: "Sweden", value: "Sweden" },
  { label: "Switzerland", value: "Switzerland" },
  { label: "Argentina", value: "Argentina" },
  { label: "Singapore", value: "Singapore" },
  { label: "Turkey", value: "Turkey" },
  { label: "Indonesia", value: "Indonesia" },
  { label: "Saudi Arabia", value: "Saudi Arabia" },
  { label: "Kazakhstan", value: "Kazakhstan" },
];

// export const holidayCalendarOptions = [
//   { label: "Holiday 1", value: "Holiday1" },
//   { label: "Holiday 2", value: "Holiday2" },
// ];

// export const weekendProfileOptions = [
//   { label: "Weekend 1", value: "Weekend1" },
//   { label: "Weekend 2", value: "Weekend2" },
// ];

// export const martialStatusOptions = [
//   { label: "Married", value: "Married" },
//   { label: "Single", value: "Single" },
// ];

// export const employeeStatusOptions = [
//   { label: "Active", value: "Active" },
//   { label: "Resignation", value: "Resignation" },
// ];

// export const ethnicityOptions = [
//   { label: "Ethnicity 1", value: "Ethnicity1" },
//   { label: "Ethnicity 2", value: "Ethnicity2" },
//   { label: "Ethnicity 3", value: "Ethnicity3" },
//   { label: "Ethnicity 4", value: "Ethnicity4" },

// ];

// export const DepartmentOptions = [
//   { label: "Accounting Consulting HR Dept", value: "AccountingConsultingHrDept" },
//   { label: "Immigration Dept", value: "ImmigrationDept" },
//   { label: "General", value: "General" },
// ];

//not changed
export const netTermsOptions = [
  { label: "Pay On Pay", value: "Pay On Pay" },
  { label: "Due On Receipt", value: "Due on receipt" },
  { label: "Net 7", value: "Net 7" },
  { label: "Net 15", value: "Net 15" },
  { label: "Net 30", value: "Net 30" },
  { label: "Net 45", value: "Net 45" },
  { label: "Net 60", value: "Net 60" },
  { label: "Net 90", value: "Net 90" },
  { label: "Net 120", value: "Net 120" },
  { label: "Net 160", value: "Net 160" },
];
//not changed
export const clientCategoryOptions = [
  { label: "Direct", value: "Direct" },
  { label: "Tier 1", value: "Tie1" },
];
//not changed
export const jobTerminationNoticeOptions = [
  { label: "10 Days", value: "10" },
  { label: "15 Days", value: "15" },
  { label: "21 Days", value: "21" },
  { label: "30 Days", value: "30" },
];

export const payableOptions = [
  { label: "Payable", value: "Payable" },
  { label: "Non-Payable", value: "Non-Payable" },
];

export const restrictBillableOptions = [
  { label: "Show Warning Only", value: "1" },
  { label: "Restrict", value: "2" },
  { label: "Do Nothing", value: "3" },
];
// export const RestrictNonBillableOptions = [
//   { label: "Show Warning Only", value: "ShowWarningOnly" },
//   { label: "Restrict", value: "Restrict" },
//   { label: "Do Nothing", value: "DoNothing" },

// ];
export const documentTypeOptions = [
  { label: "1797", value: "1797" },
  { label: "Account details proof", value: "Account Details Proof" },
  { label: "ACH", value: "Ach" },
  {
    label: "Acknowledgement from certification of Information",
    value: "Acknowledgement from certification of Information",
  },
  { label: "Addendum", value: "Addendum" },
  { label: "Addendum to the MSA", value: "Addendum to the MSA" },
  { label: "Amendment", value: "Amendment" },
  { label: "Article of corporation", value: "Article of corporation" },
];

export const vendorTypeOptions = [
  { label: "1099", value: "1099" },
  { label: "C2C", value: "C2C" },
];
export const consultantNameOptions = [
  { label: "Consultant Name 1", value: "1" },
  { label: "Consultant Name 2", value: "2" },
  { label: "Consultant Name 3", value: "3" },
  { label: "Consultant Name 4", value: "4" },
];
export const priorityOptions = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
];

export const discountTypeeOptions = [
  { label: "Percentage", value: "Percentage" },
  { label: "Value", value: "Value" },
];

export const billableClientOptions = [
  {
    label: "Spearhead Technology (CLN-120)",
    value: "Spearhead Technology (CLN-120)",
  },
  {
    label: "Altech Consulting Inc (CLN-290)",
    value: "Altech Consulting Inc (CLN-290)",
  },
  {
    label: "Apeiro Technologies Inc (CLN-030)",
    value: "Apeiro Technologies Inc (CLN-030)",
  },
  {
    label: "Artech Information Systems LLC (CLN-017)",
    value: "Artech Information Systems LLC (CLN-017)",
  },
  {
    label: "Boston Technology Corporation (CLN-178)",
    value: "Boston Technology Corporation (CLN-178)",
  },
  {
    label: "Braintree Technology Solutions LLC (CLN-089)",
    value: "Braintree Technology Solutions LLC (CLN-089)",
  },
  {
    label: "Cohesive Technologies LLC (CLN-189)",
    value: "Cohesive Technologies LLC (CLN-189)",
  },
  {
    label: "Conquest Tech Solutions Inc (CLN-162)",
    value: "Conquest Tech Solutions Inc (CLN-162)",
  },
];

export const placementsOptions = [
  {
    label: "Placement 1",
    value: "Placement 1",
  },
  {
    label: "Placement 2",
    value: "Placement 2",
  },
  {
    label: "Placement 3",
    value: "Placement 3",
  },
];

export const invoiceCalculationTypeOptions = [
  {
    label: "Invoice From Timesheets",
    value: 1,
  },
  {
    label: "Invoice Default Standard Hour Per Day",
    value: 2,
  },
];

export const invoiceFrequencyTypeOptions = [
  {
    label: "Per Week",
    value: 1,
  },
  {
    label: "BiWeekly",
    value: 2,
  },
  {
    label: "Calendar Semi Monthly",
    value: 3,
  },
  {
    label: "Calendar Month",
    value: 4,
  },
  {
    label: "By Dates",
    value: 5,
  },
  {
    label: "Apex Calendar",
    value: 6,
  },
];

export const documentOptions = [
  {
    label: "Benefit Summary",
    value: "Benefit Summary",
  },
  {
    label: "Contract Information",
    value: "Contract Information",
  },
  {
    label: "Direct Hire Agreement",
    value: "Direct Hire Agreement",
  },
  {
    label: "Extended Copy",
    value: "Extended Copy",
  },
  {
    label: "MSA",
    value: "MSA",
  },
  {
    label: "Offer Letter",
    value: "Offer Letter",
  },
  {
    label: "PO",
    value: "PO",
  },
  {
    label: "WO",
    value: "WO",
  },
];

export const approvalSelectOptions = [
  {
    label: "Reporting Manager",
    value: 1,
  },
  {
    label: "Finance Manager",
    value: 2,
  },
  {
    label: "Timesheer Approval (Group)",
    value: 3,
  },
  {
    label: "Abhi Y (EMP-1002) | Tektree",
    value: 4,
  },
  {
    label: "Ajay Patwari (CON-2079) | Tektree",
    value: 5,
  },
  {
    label: "Imran Khan (EMP-1020) | Tektree",
    value: 6,
  },
  {
    label: "Kiran Kumar (EMP-1030) | Tektree",
    value: 7,
  },
];

export const restrictBillableHoursOptions = [
  { label: "Show Warning Only", value: "1" },
  { label: "Restrict", value: "2" },
  { label: "Do Nothing", value: "3" },
];
export const consultantSourceOptions = [
  { label: "NA", value: "Na" },
  { label: "Tektree", value: "Tektree" },
];

export const jobTitleOptions = [
  { label: "Architect", value: "Architect" },
  { label: "Design Engineer", value: "Design Engineer" },
  { label: "IT Manager", value: "IT Manager" },
  { label: "Dev", value: "Dev" },
  { label: "System Administration", value: "System Administration" },
  { label: "Sr. Techops Engineer", value: "Sr. Techops Engineer" },
  { label: "Scrum Master", value: "Scrum Master" },
  { label: "Technical Business Analyst", value: "Technical Business Analyst" },
];

export const discountTypeOptions = [
  { label: "Value", value: 1 },
  { label: "Percentage", value: 2 },
];

export const invoiceOptions = [
  { label: "Immediately", value: "Immediately" },
  { label: "One Month", value: "One Month" },
  { label: "Two Months", value: "Two Months" },
  { label: "Three Months", value: "Three Months" },
  { label: "Six Months", value: "Six Months" },
  { label: "Specific Date", value: "Specific Date" },
];

export const itemIncomeAccountOptions = [
  { label: "Select", value: "Select" },
  { label: "Checking", value: "Checking" },
  { label: "Citizen Bank Checking", value: "Citizen Bank Checking" },
  { label: "Citizens Bank", value: "Citizens Bank" },
  {
    label: "Reserve Account (Chesapeak Bank)",
    value: "Reserve Account (Chesapeak Bank)",
  },
  { label: "Saving Account", value: "Saving Account" },
  { label: "Undeposited Funds", value: "Undeposited Funds" },
];

export const itemCategoryOptions = [
  { label: "Select", value: "Select" },
  { label: "A", value: "A" },
];
export const itemSubCategoryOptions = [
  { label: "Select", value: "Select" },
  { label: "A", value: "A" },
];

export const documentType = [
  { label: "1-9", value: "1-9" },
  { label: "A4", value: "A4" },
  { label: "ACH form", value: "ACH form" },
  {
    label: "Acknowledgement Form",
    value: "Acknowledgement Form",
  },
  {
    label: "Acknowledgement from certification of Information",
    value: "Acknowledgement from certification of Information",
  },
  {
    label: "Acknowledgement & direct deposit",
    value: "Acknowledgement & direct deposit",
  },
  { label: "Addendum Extension", value: "Addendum Extension" },
  { label: "Agreement EXHIBIT A", value: "Agreement EXHIBIT A" },
  {
    label: "Authorization for Direct deposit",
    value: "Authorization for Direct deposit",
  },
];

export const status = [
  { label: "Active", value: "Active" },
  { label: "Feild Extension", value: "Feild Extension" },
  { label: "In Active", value: "In Active" },
];

export const federalFilingStatus = [
  {
    label: "Single or Married filing separately",
    value: 1,
  },
  {
    label: "Married filing jointly or Qualifying surviving spouse",
    value: 2,
  },
  { label: "Head of Household", value: 3 },
];

export const suiState = [
  { label: "Phoenix", value: "Phoenix" },
  { label: "Atlanta", value: "Atlanta" },
  { label: "Lansing", value: "Lansing" },
  { label: "Helena", value: "Helena" },
];
export const w2Year = [
  { label: "2025", value: "2025" },
  { label: "2024", value: "2024" },
  { label: "2023", value: "2023" },
  { label: "2022", value: "2022" },
  { label: "2021", value: "2021" },
  { label: "2020", value: "2020" },
  { label: "2019", value: "2019" },
  { label: "2018", value: "2018" },
  { label: "2017", value: "2017" },
  { label: "2016", value: "2016" },
];
export const stateWithheld = [
  { label: "Alaska", value: "Alaska" },
  { label: "Alabama", value: "Alabama" },
  { label: "Arkansas", value: "Arkansas" },
  { label: "Arizona", value: "Arizona" },
  { label: "California", value: "California" },
  { label: "Colorado", value: "Colorado" },
  { label: "Connecticut", value: "Connecticut" },
  { label: "District of Columbia", value: "District of Columbia" },
];
export const placementOptions = [
  {
    label: "Siebel Lead Developer(Shu-001)-Sukumar Mididodi",
    value: "Siebel Lead Developer(Shu-001)-Sukumar Mididodi",
  },
  {
    label: "Software Engineer III_Seaglass(SeaglassTech_001)-Sukumar Mididodi",
    value: "Software Engineer III_Seaglass(SeaglassTech_001)-Sukumar Mididodi",
  },
  {
    label: "Technical Consultant_Computer Aid Inc(CAI-001)-Sukumar Mididodi",
    value: "Technical Consultant_Computer Aid Inc(CAI-001)-Sukumar Mididodi",
  },
];

export const w4Form = [
  { label: "Previous W-4", value: "Previous W-4" },
  { label: "2020 W-4", value: "2020 W-4" },
  { label: "2021 W-4", value: "021 W-4" },
  { label: "2022 W-4", value: "2022 W-4" },
  { label: "2023 W-4", value: "2023 W-4" },
  { label: "2024 W-4", value: "2024 W-4" },
  { label: "2025 W-4", value: "2025 W-4" },
  { label: "Filed Extension", value: "Filed Extension" },
];

export const classOfAdmissionOption = [
  { label: "Green Card", value: "1" },
  { label: "Citizen", value: "2" },
  { label: "H-1B", value: "3" },
  { label: "OPT", value: "4" },
  { label: "CPT", value: "5" },
  { label: "H4", value: "6" },
  { label: "STEM OPT", value: "7" },
  { label: "L2 EAD", value: "8" },
];
export const eVerifiedByOption = [
  { label: "Reporting Manager", value: "1" },
  { label: "Raghuveer Bandi", value: "2" },
  { label: "Timesheet Approval (Group)", value: "3" },
  { label: "Abhi Y (EMP-1002) | Tektree", value: "4" },
  { label: "Ajay Patwari (CON-2079) | Tektree", value: "5" },
  { label: "Imran Khan (Emp-1020) | Tektree", value: "6" },
  { label: "Kiran Kumar (EMP-2030) | Tektree", value: "7" },
];

export const WADocType = [
  { label: "Citizen", value: "Citizen" },
  { label: "CPT", value: "CPT" },
  // { label: "Driving License", value: "Driving License" },
  { label: "GC EAD", value: "GC EAD" },
  { label: "Green Card", value: "Green Card" },
  { label: "H-1B", value: "H-1B" },
  { label: "H4", value: "H4" },
  { label: "H4 EAD", value: "H4 EAD" },
  { label: "L2 EAD", value: "L2 EAD" },
  { label: "OPT", value: "OPT" },
  { label: "STEM OPT", value: "STEM OPT" },
];

export const discountOptions = [
  { label: "Invoice Discount", value: "Invoice Discount" },
  { label: "Payment Discount", value: "Payment Discount" },
];

export const emailAddToBodyOrSubjectOptions = [
  { label: "Add to Body", value: "Add to Body" },
  { label: "Add to Subject", value: "Add to Subject" },
];

export const emailSelectOptions = [
  { label: "Employee First Name", value: "Employee First Name" },
  { label: "Employee Last Name", value: "Employee Last Name" },
  { label: "Employee Full Name", value: "Employee Full Name" },
  { label: "Employee Contact Number", value: "Employee Contact Number" },
  { label: "Employee Last Email", value: "Employee Last Email" },
  { label: "Employee Reporting Manager", value: "Employee Reporting Manager" },
  { label: "Employee Finance Manager", value: "Employee Finance Manager" },
  { label: "Employee Hr Manager", value: "Employee Hr Manager" },
];

export const AdvertisementsOptions = [
  { label: "Java", value: "Java" },
  { label: "Programmer Analyst", value: "Programmer Analyst" },
  { label: "Software Engineer", value: "Software Engineer" },
];

export const laborCategory = [
  { label: "EB 1", value: "EB 1" },
  { label: "EB 2", value: "EB 2" },
  { label: "EB 3", value: "EB 3" },
];

export const greenCardClasificationOptions = [
  { label: "Normal", value: "Normal" },
  { label: "Premium", value: "Premium" },
];

export const processingTypeOptions = [
  { label: "Normal", value: "Normal" },
  { label: "Premium", value: "Premium" },
];

export const greenCardStatusOptions = [
  { label: "Filed", value: "Filed" },
  { label: "Received", value: "Received" },
];
export const bloodGroupOptions = [
  { label: "O+", value: "O+" },
  { label: "O-", value: "O-" },
  { label: "RFE Received-", value: "RFE Received-" },
  { label: "Denied", value: "Denied" },
  { label: "B-", value: "B-" },
  { label: "RFE Approved", value: "RFE Approved" },
  { label: "AB-", value: "AB-" },
  { label: "Doesn’t wish to disclose", value: "Doesn’t wish to disclose" },
];

export const ClientPaymentOpetions = [
  {
    label: "Client Resources Inc | CLN-039",
    value: "CLN-039",
  },
  {
    label: "Cloudious LLC | CLN-091",
    value: "CLN-091",
  },
  {
    label: "Clovity | CLN-200",
    value: "Clovity | CLN-200",
  },
  {
    label: "Cohesive Technologies, LLC | CLN-189",
    value: "Cohesive Technologies, LLC | CLN-189",
  },
  {
    label: "Collabera Inc | CLN-003",
    value: "Collabera Inc | CLN-003",
  },
  {
    label: "Compubahn Inc | CLN-022",
    value: "Compubahn Inc | CLN-022",
  },
  {
    label: "Compunnel Inc | CLN-100",
    value: "Compunnel Inc | CLN-100",
  },
  {
    label: "Compunnel Inc | CLN-249",
    value: "Compunnel Inc | CLN-249",
  },
];

export const ClientPaymentAccountTypeOpetions = [
  {
    label: "Checking",
    value: "Checking",
  },
  {
    label: "Citizen Bank Checking",
    value: "CitizenBankChecking",
  },
  {
    label: "Citizens Bank",
    value: "CitizensBank",
  },
  {
    label: "Reserve Account (Chesapeake Bank)",
    value: "ReserveAccount(Chesapeake Bank)",
  },
  {
    label: "Savings Account",
    value: "SavingsAccount",
  },
  {
    label: "Undeposited Funds",
    value: "UndepositedFunds",
  },
];
export const ClientPaymentmethodOpetions = [
  {
    label: "Account Transfer",
    value: "AccountTransfer",
  },
  {
    label: "ACH",
    value: "ACH",
  },
  {
    label: "ACH Payment",
    value: "ACHPayment",
  },
  {
    label: "Amount ayable",
    value: "AmountPayable",
  },
  {
    label: "Cash",
    value: "Cash",
  },
  {
    label: "Cash Flow",
    value: "CashFlow",
  },
  {
    label: "Cash Flow & Gatway",
    value: "CashFlowGatway",
  },
  {
    label: "Check",
    value: "Check",
  },
  {
    label: "Check Payment",
    value: "CheckPayment",
  },
  {
    label: "Cheque Payment",
    value: "ChequePayment",
  },
  {
    label: "Client Reimbursement",
    value: "ClientReimbursement",
  },
  {
    label: "Corporate Credit Card",
    value: "CorporateCreditCard",
  },
  {
    label: "Credit Card",
    value: "CreditCard",
  },
  {
    label: "Gateway",
    value: "Gateway",
  },
  {
    label: "Online Payment",
    value: "OnlinePayment",
  },
  {
    label: "Paid From Salary",
    value: "PaidFromSalary",
  },
  {
    label: "Reimbursement",
    value: "Reimbursement",
  },
  {
    label: "Salary",
    value: "Salary",
  },
  ,
];

export const SendExitNotificationOptions = [
  {
    label: "Aaron Carter (rouxasch29@indeedemail.com)+",
    value: "Aaron Carter (rouxasch29@indeedemail.com)",
  },
  {
    label: "ABDELILAH CHENNAOUI (abdelilah.chennaoui@gmail.com)",
    value: "ABDELILAH CHENNAOUI (abdelilah.chennaoui@gmail.com)",
  },
  {
    label: "Abdul Muqeeth (hr@wisefolkstech.com)",
    value: "Abdul Muqeeth (hr@wisefolkstech.com)",
  },
  {
    label: "Abdul Waseem Syed (abdul4rpa@gmail.com)",
    value: "Abdul Waseem Syed (abdul4rpa@gmail.com)",
  },
  {
    label: "Abhi Y (abhi@tektreeinc.com)",
    value: "Abhi Y (abhi@tektreeinc.com)",
  },
  {
    label: "Adeeb Khan Mohammed (kadeeb1995@gmail.com)",
    value: "Adeeb Khan Mohammed (kadeeb1995@gmail.com)",
  },
  {
    label: "Aditya Vikram (Adityavikram622@gmail.com)",
    value: "Aditya Vikram (Adityavikram622@gmail.com)",
  },
  {
    label: "Aishwarya Vedula (vedulaaishwarya@gmail.com)",
    value: "Aishwarya Vedula (vedulaaishwarya@gmail.com)",
  },
  {
    label: "Aishwarya Singireddy (Israo1815@gmail.com)",
    value: "Aishwarya Singireddy (Israo1815@gmail.com)",
  },
];

export const ExitTypeOptions = [
  {
    label: "Absconding",
    value: "Absconding",
  },
  {
    label: "Resignation",
    value: "Resignation",
  },
];

export const CreateInvoiceByOptions = [
  {
    label: "By Client",
    value: 1,
  },
  {
    label: "By Employee",
    value: 2,
  },
  {
    label: "Manual",
    value: 3,
  },
];
export const InvoiceClientOptions = [
  {
    label: "ShubhaMinds, LLC | CLN-250",
    value: "ShubhaMinds, LLC | CLN-250",
  },
  {
    label: "Gemma Power Systems, LLC | CLN-246",
    value: "Gemma Power Systems, LLC | CLN-246",
  },
  {
    label: "Spearhead Technology | CLN-120",
    value: "Spearhead Technology | CLN-120",
  },
  {
    label: "4 CONSULTING INC. | CLN-258",
    value: "4 CONSULTING INC. | CLN-258",
  },
  {
    label: "4 Peaks Business Solutions LLC | CLN-063",
    value: "4 Peaks Business Solutions LLC | CLN-063",
  },
  {
    label: "A&K Construction, Inc | CLN-289",
    value: "A&K Construction, Inc | CLN-289",
  },
  {
    label: "ADITI CONSULTING LLC | CLN-087",
    value: "ADITI CONSULTING LLC | CLN-087",
  },
];

export const InvoiceEmployeesOptions = [
  {
    label: "Goutham Peddyreddy - VDart Inc",
    value: "Goutham Peddyreddy - VDart Inc",
  },
  {
    label: "Ramesh Manthri - VDart Inc",
    value: "Ramesh Manthri - VDart Inc",
  },
  {
    label: "ANKUR VATS - Anveta Inc",
    value: "ANKUR VATS - Anveta Inc",
  },
  {
    label: "Abdul Wasem Syed - Randstad Technologies",
    value: "Abdul Wasem Syed - Randstad Technologies",
  },
  {
    label: "Abhiram Pothuraju - Collabera Inc",
    value: "Abhiram Pothuraju - Collabera Inc",
  },
  {
    label: "Abhiram Tayi - Veritude LLC",
    value: "Abhiram Tayi - Veritude LLC",
  },
  {
    label: "Abubakar Mohammed - Mindtree Consulting Ltd",
    value: "Abubakar Mohammed - Mindtree Consulting Ltd",
  },
  {
    label: "Abdul Waseem - Zodiac Solutions Inc",
    value: "Abdul Waseem - Zodiac Solutions Inc",
  },
];

export const BulkInvoicesPeriodOptions = [
  {
    label: "Current Month",
    value: "Current Month",
  },
  {
    label: "Last Month",
    value: "Last Month",
  },
  {
    label: "Last 3 Months",
    value: "Last 3 Months",
  },
  {
    label: "Last 6 Months",
    value: "Last 6 Months",
  },
  {
    label: "Last 12 Months",
    value: "Last 12 Months",
  },
];
export const BulkInvoicesClientOptions = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Corporate Biz Solutions Inc | CLN-086",
    value: "Corporate Biz Solutions Inc | CLN-086",
  },
  {
    label: "Gemma Power Systems, LLC | CLN-246",
    value: "Gemma Power Systems, LLC | CLN-246",
  },
  {
    label: "Spearhead Technology | CLN-120",
    value: "Spearhead Technology | CLN-120",
  },
  {
    label: "4 CONSULTING INC | CLN-258",
    value: "4 CONSULTING INC | CLN-258",
  },
  {
    label: "4 Peaks Business Solutions LLC | CLN-063",
    value: "4 Peaks Business Solutions LLC | CLN-063",
  },
  {
    label: "A&K Construction, Inc | CLN-289",
    value: "A&K Construction, Inc | CLN-289",
  },
  {
    label: "ADITI CONSULTING LLC | CLN-087",
    value: "ADITI CONSULTING LLC | CLN-087",
  },
  {
    label: "Adjustment | CLN-164",
    value: "Adjustment | CLN-164",
  },
  {
    label: "Aerospike Inc | CLN-203",
    value: "Aerospike Inc | CLN-203",
  },
  {
    label: "AgreeYa Solutions, Inc | CLN-238",
    value: "AgreeYa Solutions, Inc | CLN-238",
  },
];

export const BulkInvoicesEmployeeOptions = [
  {
    label: "All Employees",
    value: "All Employees",
  },
  {
    label: "Abhi Y",
    value: "Abhi Y",
  },
  {
    label: "Abdul Waseem Syed",
    value: "Abdul Waseem Syed",
  },
  {
    label: "Abhiram Taya",
    value: "Abhiram Taya",
  },
  {
    label: "Abhiram Pothuraju",
    value: "Abhiram Pothuraju",
  },
  {
    label: "Aditya Paramacula",
    value: "Aditya Paramacula",
  },
  {
    label: "Amulya Dirisala",
    value: "Amulya Dirisala",
  },
];
export const BulkInvoicesLineItemsOptions = [
  {
    label: "Consolidate by Invoice Frequency",
    value: "Consolidate by Invoice Frequency",
  },
  {
    label: "Consolidate by Timesheet Frequency",
    value: "Consolidate by Timesheet Frequency",
  },
  {
    label: "Split by Calendar month",
    value: "Split by Calendar month",
  },
  {
    label: "Split By Each Day",
    value: "Split By Each Day",
  },
];
export const DependentOptions = [
  {
    label: "Aaron Carter (CON-2064)",
    value: "Aaron Carter (CON-2064)",
  },
  {
    label: "ABDELILAH CHENNAOUI (CON-2109)",
    value: "ABDELILAH CHENNAOUI (CON-2109)",
  },
  {
    label: "Abdul Muqeeth (CON-2001)",
    value: "Abdul Muqeeth (CON-2001)",
  },
  {
    label: "Abdul Waseem Syed (EMP-1001)",
    value: "Abdul Waseem Syed (EMP-1001)",
  },
  {
    label: "Abhi Y (EMP-1002)",
    value: "Abhi Y (EMP-1002)",
  },
  {
    label: "Adeeb Khan Mohammed (EMP-070)",
    value: "Adeeb Khan Mohammed (EMP-070)",
  },
  {
    label: "Aditya Vikram (CON-2060)",
    value: "Aditya Vikram (CON-2060)",
  },
];
export const RelatonShipOptions = [
  {
    label: "Father",
    value: "Father",
  },
  {
    label: "Mother",
    value: "Mother",
  },
  {
    label: "Spouse",
    value: "Spouse",
  },
  {
    label: "Child",
    value: "Child",
  },
];
export const CostTypeOptions = [
  {
    label: "Attorney Charges",
    value: "Attorney Charges",
  },
  {
    label: "Premium Processing Fee",
    value: "Premium Processing Fee",
  },
  {
    label: "Visa Processing Fee",
    value: "Visa Processing Fee",
  },
];

export const eonboardingDocumentcategory = [
  {
    label: "C2C",
    value: "C2C",
  },
  {
    label: "C2C Onboarding",
    value: "C2C Onboarding",
  },
  {
    label: "CPT Onboarding",
    value: "CPT Onboarding",
  },
  {
    label: "OPT Initial Onboarding",
    value: "OPT Initial Onboarding",
  },
  {
    label: "OPT STEM Onboarding",
    value: "OPT STEM Onboarding",
  },
  {
    label: "Test Category",
    value: "Test Category",
  },
  {
    label: "Test supporting document",
    value: "Test supporting document",
  },
];
export const eonboardingsupportingdocumnt = [];

export const CEIPALWorkforceopetions = [
  {
    label: "Applicant : SSN - WFSF002",
    value: "Applicant : SSN - WFSF002",
  },
  {
    label: "Applicant : Bank Details (Direct Deposits) - WFSF001",
    value: "Applicant : Bank Details (Direct Deposits) - WFSF001",
  },
  {
    label: "Applicant : Emergency Contact - WFSF008",
    value: "Applicant : Emergency Contact - WFSF008",
  },
  {
    label: "Applicant : Permanent Address - WFSF007",
    value: "Applicant : Permanent Address - WFSF007",
  },
  {
    label: "Applicant : Present Address - WFSF006",
    value: "Applicant : Present Address - WFSF006",
  },
  {
    label: "Applicant : I-94 - WFSF005",
    value: "Applicant : I-94 - WFSF005",
  },
  {
    label: "Applicant : Passport - WFSF004",
    value: "Applicant : Passport - WFSF004",
  },
  {
    label: "Applicant : Insurance Form - WFSF003",
    value: "Applicant : Insurance Form - WFSF003",
  },
];

export const W2_H1BOnboarding = [
  {
    label: "Applicant : TekTree_Employment Agreement - DOC17",
    value: "Applicant : TekTree_Employment Agreement - DOC17",
  },
  {
    label: "Applicant : TekTree_Employment Agreement Exhibits_DOC18",
    value: "Applicant : TekTree_Employment Agreement Exhibits_DOC18",
  },
  {
    label: "Applicant : Acknowledgment Form Certification of Information-DOC52",
    value: "Applicant : Acknowledgment Form Certification of Information-DOC52",
  },
  {
    label: "Applicant : TekTree_Offer Letter - DOC53",
    value: "Applicant : TekTree_Offer Letter - DOC53",
  },
];

export const W2H1BOnboarding = [
  {
    label: "Applicant : TekTree Definite Employment Agreement Exhibits-DOC48",
    value: "Applicant : TekTree Definite Employment Agreement Exhibits-DOC48",
  },
  {
    label: "Applicant : TekTree_Acknowledgment Form - DOC50",
    value: "Applicant : TekTree_Acknowledgment Form - DOC50",
  },
  {
    label: "Applicant : All Savers_Insurance Waiver - DOC51",
    value: "Applicant : All Savers_Insurance Waiver - DOC51",
  },
  {
    label: "Applicant : TekTree Definite Employment Agreement - DOC54",
    value: "Applicant : TekTree Definite Employment Agreement - DOC54",
  },
];
export const InvoiceFrequencyOptions = [
  {
    label: "By Dates",
    value: "By Dates",
  },
  // {
  //   label: "By System Intervals",
  //   value: "By System Intervals",
  // },
];
export const CreditTypeOptions = [
  {
    label: "Retain as Available Credit",
    value: "Retain as Available Credit",
  },
  {
    label: "Apply to an Invoice",
    value: "Apply to an Invoice",
  },
];
export const Paymenttypeopetions = [
  {
    label: "Salaried",
    value: 1,
  },
  {
    label: "As Per Placements",
    value: 2,
  },
  {
    label: "Salary As Per Placements",
    value: 3,
  },
]

export const BasepayOpetions = [
  {
    label: "Pay Cycle",
    value: "Pay Cycle",
  },
  {
    label: "Per Hour",
    value: "Per Hour",
  },
  {
    label: "Per Annum",
    value: "Per Annum",
  },
]

export const perDiemPaymentTypeOptions = [
  {
    label: "Not Applicable",
    value: "Not Applicable",
  },
  {
    label: "Fixed Per Pay Period",
    value: "Fixed Per Pay Period",
  },
  {
    label: "Pay as per Placements",
    value: "Pay as per Placements",
  },
];

export const jobstatusopetions = [
  {
    lable: "Select",
    value: "Select"
  },
  {
    lable: "Draft",
    value: "Draft"
  },
  {
    lable: "Active",
    value: "Active"
  },
  {
    lable: "Inactive",
    value: "Inactive"
  }
]


export const PayProfileoptions = [
  {
    label: "W2Payroll (Monthly) (Monthly)",
    value: "W2Payroll (Monthly) (Monthly)"
  },
  {
    label: "Bi-Monthly (W2) (Semi Monthly)",
    value: "Bi-Monthly (W2) (Semi Monthly)"
  },
]

export const PayProfile = [

  {
    label: "Placement 1",
    value: "Placement 1"
  },
  {
    label: "Placement 2",
    value: "Placement 2"
  },
  {
    label: "Placement 3",
    value: "Placement 3"
  },
]


export const PayPeriodoptions = [
  {
    label: "02/01/2025-02/28/2025",
    value: "02/01/2025-02/28/2025"
  },
  {
    label: "03/01/2025-03/31/2025",
    value: "03/01/2025-03/31/2025"
  },
  {
    label: "04/01/2025-04/30/2025",
    value: "04/01/2025-04/30/2025"
  },



]

export const Basepayopetions = [
  {
    label: "Pay Cycle",
    value: "Pay Cycle"
  },
  {
    label: "Per Hour",
    value: "Per Hour"
  },
  {
    label: "Per Annum",
    value: "Per Annum"
  },
]



export const deductionoprtions = [
  {
    label: "Legal",
    value: 1
  },
  {
    label: "Health Insurance",
    value:2
  },

]
export const DeductionName = [
  {
    label: "H1B",
    value: "H1B"
  },
  {
    label: "GC",
    value: "GC   "
  },
  {
    label: "Pom",
    value: "Pom"
  },

]
export const PaymentTypeoprtions = [
  {
    label: "Not To Detect",
    value: 1
  },
  {
    label: "Installment Plan",
    value: 2
  },
  {
    label: "Recurring Untill",
    value:3
  },
]

export const startcycleopetion = [
  {
    label: "02/01/2025-02/28/2025",
    value: "02/01/2025-02/28/2025"
  },
  {
    label: "03/01/2025-03/31/2025",
    value: "03/01/2025-03/31/2025"
  },
  {
    label: "04/01/2025-04/30/2025",
    value: "04/01/2025-04/30/2025"
  },
]


export const LCStypes = [
  {
    label: "Monthly",
    value: 1
  },
  {
    label: "Yearly",
    value: 2
  }
]

export const vendortypes = [
  {
    label: "11549430 Canada Corp",
    value: "11549430 Canada Corp"
  },
  {
    label: "13986641 Canada Inc",
    value: "13986641 Canada Inc"
  },
  {
    label: "14111605 Canada Inc",
    value: "14111605 Canada Inc"
  },
  {
    label: "47 Billion Inc",
    value: "47 Billion Inc"
  },
  {
    label: "9090533 CANADA INC",
    value: "9090533 CANADA INC"
  },
  {
    label: "Algol Software LLC",
    value: "Algol Software LLC"
  },
  {
    label: "AvevoTech Inc",
    value: "AvevoTech Inc"
  },

]


export const AccountpayableAccountType = [
  {
    label: "Checking (QB)",
    value: "Checking (QB)"
  },
  {
    label: "Citizen Bank Checking (QB)",
    value: "Citizen Bank Checking (QB)"
  },
  {
    label: "Citizens Bank (QB)",
    value: "Citizens Bank (QB)"
  },
  {
    label: "Reserve Account (Chesapeake Bank)",
    value: "Reserve Account (Chesapeake Bank)"
  },
  {
    label: "Savings Account (QB)",
    value: "Savings Account (QB)"
  },
  {
    label: "Undeposited Funds",
    value: "Undeposited Funds"
  },
]

export const Accountpayablepaytype = [
  {
    label: "Account Transfer",
    value: "Account Transfer"
  },
  {
    label: "ACH",
    value: "ACH"
  },
  {
    label: "ACH Payment",
    value: "ACH Payment"
  },
  {
    label: "Amount Payable",
    value: "Amount Payable"
  },
  {
    label: "Cash",
    value: "Cash"
  },
  {
    label: "Cash Flow",
    value: "Cash Flow"
  },
  {
    label: "Cash Flow & Gateway",
    value: "Cash Flow & Gateway"
  },
  {
    label: "Check (QB)",
    value: "Check (QB)"
  },
  {
    label: "Check Payment",
    value: "Check Payment"
  },
  {
    label: "Cheque Payment",
    value: "Cheque Payment"
  },
  {
    label: "Client Reimbursement",
    value: "Client Reimbursement"
  },
  {
    label: "Corporate Credit Card",
    value: "Corporate Credit Card"
  },
]



export const upcommingpayfrequency = [
  { value: "Weekly", label: "Weekly" },
  { value: "Bi Weekly", label: "Bi Weekly" },
  { value: "Semi Monthly", label: "Semi Monthly" },
  { value: "Monthly", label: "Monthly" },
]

export const ExpensesAmountoptions=[
  {
    label: "Expenses",
    value: "Expenses"
  },
  {
    label: "Per Diem",
    value: "Per Diem"
  },
  {
    label: "Commission",
    value: "Commission"
  },
]

export const DropDownFilteroptions=[
  {
    label: "All",
    value: "All"
  },
  
]

export const DropDownoptionsquickbooks=[
  {
    label: "All Invoices",
    value: "All Invoices"
  },
  {
    label: "All Clients",
    value: "All Clients"
  },
  {
    label: "All Invoice Payment",
    value: "All Invoice Payment"
  },
  {
    label: "All AP Invoice",
    value: "All AP Invoice"
  },
  {
    label: "All AP Invoice Payment",
    value: "All AP Invoice Payment"
  },
  {
    label: "All Timesheets",
    value: "All Timesheets"
  },
  
]
export const SubContractingOptions=[
  {
    label: "Allowed",
    value: 1
  },
  {
    label: "Not Allowed",
    value: 2
  },
  {
    label: "Allowed With Consent",
    value: 3
  },
  
]
export const ContigentPaymentOptions=[
  {
    label: "Contigent",
    value: 1
  },
  {
    label: "Non-Contigent",
    value: 2
  },
  
  
]
export const RightToHireOptions=[
  {
    label: "Client Can Hire",
    value: 1
  },
  {
    label: "End Client Can Hire",
    value:2
  },
  {
    label: "End Client Can Hire",
    value: 3
  },
  {
    label: "Client & End Client Can Hire",
    value: 4
  },
  {
    label: "Tektree Can Hire",
    value: 5
  },
  
  
]
export const LiquidatedDamageOptions=[
  {
    label: "No Clause",
    value: 1
  },
  {
    label: "Court of Law",
    value: 2
  },
  {
    label: "500* Hours",
    value: 3
  },
  
  
  
]
export const IndemnificationOptions=[
  {
    label: "Client",
    value: 1
  },
  {
    label: "Client and Its Clients",
    value: 2
  },
  {
    label: "End Client",
    value: 3
  },
  
  
  
]

export const placementVenderInvoiceFrequency=[
  {label:"Weekly", value:1},
  {label:"Biweekly", value:2},
  {label:"Monthly", value:3},
  {label:"Semi Monthly", value:4},
  {label:"4 Weeks" , value:5},
  {label:"By Dates", value:6}
]
export const AddEmployeeJobRoleOptions=[
  {label:"Finance Manager", value:"FINANCE"},
  {label:"Hr Manager", value:"HR"},
  {label:"Immigration Manager", value:"IMMIGRATION"}, 
]

export const campaignTimings= [
  { label: "0:30 AM", value: "00:30" },
  { label: "1:00 AM", value: "01:00" },
  { label: "1:30 AM", value: "01:30" },
  { label: "2:00 AM", value: "02:00" },
  { label: "2:30 AM", value: "02:30" },
  { label: "3:00 AM", value: "03:00" },
  { label: "3:30 AM", value: "03:30" },
  { label: "4:00 AM", value: "04:00" },
  { label: "4:30 AM", value: "04:30" },
  { label: "5:00 AM", value: "05:00" },
  { label: "5:30 AM", value: "05:30" },
  { label: "6:00 AM", value: "06:00" },
  { label: "6:30 AM", value: "06:30" },
  { label: "7:00 AM", value: "07:00" },
  { label: "7:30 AM", value: "07:30" },
  { label: "8:00 AM", value: "08:00" },
  { label: "8:30 AM", value: "08:30" },
  { label: "9:00 AM", value: "09:00" },
  { label: "9:30 AM", value: "09:30" },
  { label: "10:00 AM", value: "10:00" },
  { label: "10:30 AM", value: "10:30" },
  { label: "11:00 AM", value: "11:00" },
  { label: "11:30 AM", value: "11:30" },
  { label: "12:00 PM", value: "12:00" },
  { label: "12:30 PM", value: "12:30" },
  { label: "1:00 PM", value: "13:00" },
  { label: "1:30 PM", value: "13:30" },
  { label: "2:00 PM", value: "14:00" },
  { label: "2:30 PM", value: "14:30" },
  { label: "3:00 PM", value: "15:00" },
  { label: "3:30 PM", value: "15:30" },
  { label: "4:00 PM", value: "16:00" },
  { label: "4:30 PM", value: "16:30" },
  { label: "5:00 PM", value: "17:00" },
  { label: "5:30 PM", value: "17:30" },
  { label: "6:00 PM", value: "18:00" },
  { label: "6:30 PM", value: "18:30" },
  { label: "7:00 PM", value: "19:00" },
  { label: "7:30 PM", value: "19:30" },
  { label: "8:00 PM", value: "20:00" },
  { label: "8:30 PM", value: "20:30" },
  { label: "9:00 PM", value: "21:00" },
  { label: "9:30 PM", value: "21:30" },
  { label: "10:00 PM", value: "22:00" },
  { label: "10:30 PM", value: "22:30" },
  { label: "11:00 PM", value: "23:00" },
  { label: "11:30 PM", value: "23:30" },
  { label: "11:59 PM", value: "23:59" },
]
// export const campaignTimingsZone=[
//   { "label": "GMT-12:00 (Etc/GMT+12)", "value": "Etc/GMT+12" },
//   { "label": "GMT-11:00 (Etc/GMT+11)", "value": "Etc/GMT+11" },
//   { "label": "GMT-10:00 (Etc/GMT+10)", "value": "Etc/GMT+10" },
//   { "label": "Anchorage (America/Anchorage)", "value": "America/Anchorage" },
//   { "label": "Dawson (America/Dawson)", "value": "America/Dawson" },
//   { "label": "Creston (America/Creston)", "value": "America/Creston" },
//   { "label": "Chihuahua (America/Chihuahua)", "value": "America/Chihuahua" },
//   { "label": "Boise (America/Boise)", "value": "America/Boise" },
//   { "label": "Belize (America/Belize)", "value": "America/Belize" },
//   { "label": "Chicago (America/Chicago)", "value": "America/Chicago" },
//   { "label": "Bahia Banderas (America/Bahia_Banderas)", "value": "America/Bahia_Banderas" },
//   { "label": "Regina (America/Regina)", "value": "America/Regina" },
//   { "label": "Bogota (America/Bogota)", "value": "America/Bogota" },
//   { "label": "Detroit (America/Detroit)", "value": "America/Detroit" },
//   { "label": "Marengo (America/Indiana/Marengo)", "value": "America/Indiana/Marengo" },
//   { "label": "Caracas (America/Caracas)", "value": "America/Caracas" },
//   { "label": "Asuncion (America/Asuncion)", "value": "America/Asuncion" },
//   { "label": "Glace Bay (America/Glace_Bay)", "value": "America/Glace_Bay" },
//   { "label": "Campo Grande (America/Campo_Grande)", "value": "America/Campo_Grande" },
//   { "label": "Anguilla (America/Anguilla)", "value": "America/Anguilla" },
//   { "label": "Santiago (America/Santiago)", "value": "America/Santiago" },
//   { "label": "St Johns (America/St_Johns)", "value": "America/St_Johns" },
//   { "label": "Sao Paulo (America/Sao_Paulo)", "value": "America/Sao_Paulo" },
//   { "label": "La Rioja (America/Argentina/La_Rioja)", "value": "America/Argentina/La_Rioja" },
//   { "label": "Araguaina (America/Araguaina)", "value": "America/Araguaina" },
//   { "label": "Godthab (America/Godthab)", "value": "America/Godthab" },
//   { "label": "Montevideo (America/Montevideo)", "value": "America/Montevideo" },
//   { "label": "Bahia (America/Bahia)", "value": "America/Bahia" },
//   { "label": "Noronha (America/Noronha)", "value": "America/Noronha" },
//   { "label": "Scoresbysund (America/Scoresbysund)", "value": "America/Scoresbysund" },
//   { "label": "Cape Verde (Atlantic/Cape_Verde)", "value": "Atlantic/Cape_Verde" },
//   { "label": "Casablanca (Africa/Casablanca)", "value": "Africa/Casablanca" },
//   { "label": "Danmarkshavn (America/Danmarkshavn)", "value": "America/Danmarkshavn" },
//   { "label": "Isle of Man (Europe/Isle_of_Man)", "value": "Europe/Isle_of_Man" },
//   { "label": "Canary (Atlantic/Canary)", "value": "Atlantic/Canary" },
//   { "label": "Abidjan (Africa/Abidjan)", "value": "Africa/Abidjan" },
//   { "label": "Longyearbyen (Arctic/Longyearbyen)", "value": "Arctic/Longyearbyen" },
//   { "label": "Belgrade (Europe/Belgrade)", "value": "Europe/Belgrade" },
//   { "label": "Ceuta (Africa/Ceuta)", "value": "Africa/Ceuta" },
//   { "label": "Sarajevo (Europe/Sarajevo)", "value": "Europe/Sarajevo" },
//   { "label": "Algiers (Africa/Algiers)", "value": "Africa/Algiers" },
//   { "label": "Windhoek (Africa/Windhoek)", "value": "Africa/Windhoek" },
//   { "label": "Nicosia (Asia/Nicosia)", "value": "Asia/Nicosia" },
//   { "label": "Beirut (Asia/Beirut)", "value": "Asia/Beirut" },
//   { "label": "Cairo (Africa/Cairo)", "value": "Africa/Cairo" },
//   { "label": "Damascus (Asia/Damascus)", "value": "Asia/Damascus" },
//   { "label": "Bucharest (Europe/Bucharest)", "value": "Europe/Bucharest" },
//   { "label": "Blantyre (Africa/Blantyre)", "value": "Africa/Blantyre" },
//   { "label": "Helsinki (Europe/Helsinki)", "value": "Europe/Helsinki" },
//   { "label": "Istanbul (Europe/Istanbul)", "value": "Europe/Istanbul" },
//   { "label": "Jerusalem (Asia/Jerusalem)", "value": "Asia/Jerusalem" },
//   { "label": "Tripoli (Africa/Tripoli)", "value": "Africa/Tripoli" },
//   { "label": "Amman (Asia/Amman)", "value": "Asia/Amman" },
//   { "label": "Baghdad (Asia/Baghdad)", "value": "Asia/Baghdad" },
//   { "label": "Kaliningrad (Europe/Kaliningrad)", "value": "Europe/Kaliningrad" },
//   { "label": "Aden (Asia/Aden)", "value": "Asia/Aden" },
//   { "label": "Addis Ababa (Africa/Addis_Ababa)", "value": "Africa/Addis_Ababa" },
//   { "label": "Kirov (Europe/Kirov)", "value": "Europe/Kirov" },
//   { "label": "Astrakhan (Europe/Astrakhan)", "value": "Europe/Astrakhan" },
//   { "label": "Tehran (Asia/Tehran)", "value": "Asia/Tehran" },
//   { "label": "Dubai (Asia/Dubai)", "value": "Asia/Dubai" },
//   { "label": "Baku (Asia/Baku)", "value": "Asia/Baku" },
//   { "label": "Mahe (Indian/Mahe)", "value": "Indian/Mahe" },
//   { "label": "Tbilisi (Asia/Tbilisi)", "value": "Asia/Tbilisi" },
//   { "label": "Yerevan (Asia/Yerevan)", "value": "Asia/Yerevan" },
//   { "label": "Kabul (Asia/Kabul)", "value": "Asia/Kabul" },
//   { "label": "Mawson (Antarctica/Mawson)", "value": "Antarctica/Mawson" },
//   { "label": "Yekaterinburg (Asia/Yekaterinburg)", "value": "Asia/Yekaterinburg" },
//   { "label": "Karachi (Asia/Karachi)", "value": "Asia/Karachi" },
//   { "label": "Kolkata (Asia/Kolkata)", "value": "Asia/Kolkata" },
//   { "label": "Colombo (Asia/Colombo)", "value": "Asia/Colombo" },
//   { "label": "Kathmandu (Asia/Kathmandu)", "value": "Asia/Kathmandu" },
//   { "label": "Vostok (Antarctica/Vostok)", "value": "Antarctica/Vostok" },
//   { "label": "Dhaka (Asia/Dhaka)", "value": "Asia/Dhaka" },
//   { "label": "Rangoon (Asia/Rangoon)", "value": "Asia/Rangoon" },
//   { "label": "Davis (Antarctica/Davis)", "value": "Antarctica/Davis" },
//   { "label": "Novokuznetsk (Asia/Novokuznetsk)", "value": "Asia/Novokuznetsk" },
//   { "label": "Hong Kong (Asia/Hong_Kong)", "value": "Asia/Hong_Kong" },
//   { "label": "Krasnoyarsk (Asia/Krasnoyarsk)", "value": "Asia/Krasnoyarsk" },
//   { "label": "Brunei (Asia/Brunei)", "value": "Asia/Brunei" },
//   { "label": "Perth (Australia/Perth)", "value": "Australia/Perth" },
//   { "label": "Taipei (Asia/Taipei)", "value": "Asia/Taipei" },
//   { "label": "Choibalsan (Asia/Choibalsan)", "value": "Asia/Choibalsan" },
//   { "label": "Irkutsk (Asia/Irkutsk)", "value": "Asia/Irkutsk" },
//   { "label": "Dili (Asia/Dili)", "value": "Asia/Dili" },
//   { "label": "Pyongyang (Asia/Pyongyang)", "value": "Asia/Pyongyang" },
//   { "label": "Adelaide (Australia/Adelaide)", "value": "Australia/Adelaide" },
//   { "label": "Darwin (Australia/Darwin)", "value": "Australia/Darwin" },
//   { "label": "Brisbane (Australia/Brisbane)", "value": "Australia/Brisbane" },
//   { "label": "Melbourne (Australia/Melbourne)", "value": "Australia/Melbourne" },
//   { "label": "DumontDUrville (Antarctica/DumontDUrville)", "value": "Antarctica/DumontDUrville" },
//   { "label": "Currie (Australia/Currie)", "value": "Australia/Currie" },
//   { "label": "Chita (Asia/Chita)", "value": "Asia/Chita" },
//   { "label": "Macquarie (Antarctica/Macquarie)", "value": "Antarctica/Macquarie" },
//   { "label": "Sakhalin (Asia/Sakhalin)", "value": "Asia/Sakhalin" },
//   { "label": "Auckland (Pacific/Auckland)", "value": "Pacific/Auckland" },
//   { "label": "GMT+12:00 (Etc/GMT-12)", "value": "Etc/GMT-12" },
//   { "label": "Fiji (Pacific/Fiji)", "value": "Pacific/Fiji" },
//   { "label": "Anadyr (Asia/Anadyr)", "value": "Asia/Anadyr" },
//   { "label": "Kamchatka (Asia/Kamchatka)", "value": "Asia/Kamchatka" },
//   { "label": "GMT+13:00 (Etc/GMT-13)", "value": "Etc/GMT-13" },
//   { "label": "Apia (Pacific/Apia)", "value": "Pacific/Apia" }
// ]
export const campaignTimingsZone=[
  { label: "International Date Line West (UTC-12:00)", value: "Etc/GMT+12" },
  { label: "Coordinated Universal Time-11 (UTC-11:00)", value: "Etc/GMT+11" },
  { label: "Hawaii (UTC-10:00)", value: "Etc/GMT+10" },
  { label: "Alaska (UTC-09:00)", value: "America/Anchorage" },
  { label: "Pacific Time (US & Canada) (UTC-08:00)", value: "America/Boise" },
  { label: "Arizona (UTC-07:00)", value: "America/Creston" },
  { label: "Chihuahua, La Paz, Mazatlan (UTC-07:00)", value: "America/Chihuahua" },
  { label: "Mountain Time (US & Canada) (UTC-07:00)", value: "America/Boise" },
  { label: "Central America (UTC-06:00)", value: "America/Belize" },
  { label: "Central Time (US & Canada) (UTC-06:00)", value: "America/Chicago" },
  { label: "Guadalajara, Mexico City, Monterrey (UTC-06:00)", value: "America/Bahia_Banderas" },
  { label: "Saskatchewan (UTC-06:00)", value: "America/Regina" },
  { label: "Bogota, Lima, Quito (UTC-05:00)", value: "America/Bogota" },
  { label: "Eastern Time (US & Canada) (UTC-05:00)", value: "America/Detroit" },
  { label: "Indiana (East) (UTC-05:00)", value: "America/Indiana/Marengo" },
  { label: "Caracas (UTC-04:30)", value: "America/Caracas" },
  { label: "Asuncion (UTC-04:00)", value: "America/Asuncion" },
  { label: "Atlantic Time (Canada) (UTC-04:00)", value: "America/Glace_Bay" },
  { label: "Cuiaba (UTC-04:00)", value: "America/Campo_Grande" },
  { label: "Georgetown, La Paz, Manaus, San Juan (UTC-04:00)", value: "America/Anguilla" },
  { label: "Santiago (UTC-04:00)", value: "America/Santiago" },
  { label: "Newfoundland (UTC-03:30)", value: "America/St_Johns" },
  { label: "Brasilia (UTC-03:00)", value: "America/Sao_Paulo" },
  { label: "Buenos Aires (UTC-03:00)", value: "America/Argentina/La_Rioja" },
  { label: "Cayenne, Fortaleza (UTC-03:00)", value: "America/Araguaina" },
  { label: "Greenland (UTC-03:00)", value: "America/Godthab" },
  { label: "Montevideo (UTC-03:00)", value: "America/Montevideo" },
  { label: "Salvador (UTC-03:00)", value: "America/Bahia" },
  { label: "Coordinated Universal Time-02 (UTC-02:00)", value: "America/Noronha" },
  { label: "Azores (UTC-01:00)", value: "Atlantic/Canary" },
  { label: "Cape Verde Is. (UTC-01:00)", value: "Atlantic/Cape_Verde" },
  { label: "Casablanca (UTC)", value: "Africa/Casablanca" },
  { label: "Coordinated Universal Time (UTC)", value: "Africa/Abidjan" },
  { label: "Edinburgh, London (UTC)", value: "Europe/Isle_of_Man" },
  { label: "Monrovia, Reykjavik (UTC)", value: "America/Danmarkshavn" },
  { label: "Amsterdam, Berlin, Rome (UTC+01:00)", value: "Europe/Belgrade" },
  { label: "Sarajevo, Skopje, Warsaw (UTC+01:00)", value: "Europe/Sarajevo" },
  { label: "West Central Africa (UTC+01:00)", value: "Africa/Algiers" },
  { label: "Windhoek (UTC+01:00)", value: "Africa/Windhoek" },
  { label: "Athens, Bucharest (UTC+02:00)", value: "Europe/Bucharest" },
  { label: "Beirut (UTC+02:00)", value: "Asia/Beirut" },
  { label: "Cairo (UTC+02:00)", value: "Africa/Cairo" },
  { label: "Damascus (UTC+02:00)", value: "Asia/Damascus" },
  { label: "Helsinki, Kyiv (UTC+02:00)", value: "Europe/Helsinki" },
  { label: "Jerusalem (UTC+02:00)", value: "Asia/Jerusalem" },
  { label: "Tripoli (UTC+02:00)", value: "Africa/Tripoli" },
  { label: "Istanbul (UTC+03:00)", value: "Europe/Istanbul" },
  { label: "Amman (UTC+03:00)", value: "Asia/Amman" },
  { label: "Baghdad (UTC+03:00)", value: "Asia/Baghdad" },
  { label: "Kaliningrad (UTC+02:00)", value: "Europe/Kaliningrad" },
  { label: "Tehran (UTC+03:30)", value: "Asia/Tehran" },
  { label: "Abu Dhabi, Muscat (UTC+04:00)", value: "Asia/Dubai" },
  { label: "Baku (UTC+04:00)", value: "Asia/Baku" },
  { label: "Port Louis (UTC+04:00)", value: "Indian/Mahe" },
  { label: "Tbilisi (UTC+04:00)", value: "Asia/Tbilisi" },
  { label: "Yerevan (UTC+04:00)", value: "Asia/Yerevan" },
  { label: "Kabul (UTC+04:30)", value: "Asia/Kabul" },
  { label: "Islamabad, Karachi (UTC+05:00)", value: "Asia/Karachi" },
  { label: "Yekaterinburg (UTC+05:00)", value: "Asia/Yekaterinburg" },
  { label: "Chennai, Kolkata, Mumbai, New Delhi (UTC+05:30)", value: "Asia/Kolkata" },
  { label: "Sri Jayawardenepura (UTC+05:30)", value: "Asia/Colombo" },
  { label: "Kathmandu (UTC+05:45)", value: "Asia/Kathmandu" },
  { label: "Dhaka (UTC+06:00)", value: "Asia/Dhaka" },
  { label: "Yangon (Rangoon) (UTC+06:30)", value: "Asia/Rangoon" },
  { label: "Bangkok, Hanoi, Jakarta (UTC+07:00)", value: "Asia/Novokuznetsk" },
  { label: "Beijing, Hong Kong (UTC+08:00)", value: "Asia/Hong_Kong" },
  { label: "Perth (UTC+08:00)", value: "Australia/Perth" },
  { label: "Taipei (UTC+08:00)", value: "Asia/Taipei" },
  { label: "Irkutsk (UTC+08:00)", value: "Asia/Irkutsk" },
  { label: "Seoul (UTC+09:00)", value: "Asia/Pyongyang" },
  { label: "Adelaide (UTC+09:30)", value: "Australia/Adelaide" },
  { label: "Darwin (UTC+09:30)", value: "Australia/Darwin" },
  { label: "Brisbane (UTC+10:00)", value: "Australia/Brisbane" },
  { label: "Canberra, Melbourne, Sydney (UTC+10:00)", value: "Australia/Melbourne" },
  { label: "Auckland, Wellington (UTC+12:00)", value: "Pacific/Auckland" },
  { label: "Coordinated Universal Time+12 (UTC+12:00)", value: "Etc/GMT-12" },
  { label: "Fiji (UTC+12:00)", value: "Pacific/Fiji" },
  { label: "Kamchatka (UTC+12:00)", value: "Asia/Kamchatka" },
  { label: "Nuku'alofa (UTC+13:00)", value: "Etc/GMT-13" },
  { label: "Samoa (UTC+13:00)", value: "Pacific/Apia" }
]

